import { useCallback, useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { PageHeader } from "@/components/PageHeader";
import { DevisForm, eur } from "@/components/DevisForm";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";
import { Download } from "lucide-react";

const STATUTS = [["brouillon", "Brouillon"], ["envoye", "Envoyé"], ["accepte", "Accepté"], ["refuse", "Refusé"]];

export async function ouvrirPdf(url, nom) {
  const r = await api.get(url, { responseType: "blob" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(r.data);
  a.download = nom;
  a.click();
  URL.revokeObjectURL(a.href);
}

export default function Devis() {
  const { user } = useAuth();
  const canEdit = ["admin", "gestionnaire_ge", "finance"].includes(user?.role);
  const [rows, setRows] = useState([]);
  const load = useCallback(() => api.get("/devis").then((r) => setRows(r.data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);
  const statut = async (d, s) => {
    try { await api.patch(`/devis/${d.id}/statut`, { statut: s }); toast.success("Statut mis à jour"); load(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail) || e.message); }
  };
  return (
    <div className="space-y-8" data-testid="devis-page">
      <PageHeader title="Devis" subtitle="Simulation pour un prospect (moteur du simulateur public) ou une entreprise membre (paramètres financiers du GE), PDF archivé en GED." />
      <DevisForm canEdit={canEdit} onSaved={load} />
      <div className="rounded-xl border border-slate-200 bg-white divide-y" data-testid="devis-liste">
        {rows.length === 0 && <p className="p-5 text-sm text-slate-500">Aucun devis enregistré.</p>}
        {rows.map((d) => (
          <div key={d.id} className="p-4 flex flex-wrap items-center gap-3 justify-between" data-testid={`devis-row-${d.id}`}>
            <div className="min-w-0">
              <div className="font-medium text-slate-900">{d.numero} · {d.destinataire?.nom}</div>
              <div className="text-xs text-slate-500">{d.base === "prospect" ? "Prospect" : "Membre"} · {new Date(d.created_at).toLocaleDateString("fr-FR")} · HT {eur(d.resultat?.sous_total_ht)} · TTC {eur(d.resultat?.total_ttc)}</div>
            </div>
            <div className="flex items-center gap-2">
              {canEdit ? (
                <Select value={d.statut} onValueChange={(s) => statut(d, s)}>
                  <SelectTrigger className="w-32 h-8" data-testid={`devis-statut-${d.id}`}><SelectValue /></SelectTrigger>
                  <SelectContent>{STATUTS.map(([v, l]) => <SelectItem key={v} value={v}>{l}</SelectItem>)}</SelectContent>
                </Select>
              ) : <span className="text-xs">{STATUTS.find(([v]) => v === d.statut)?.[1]}</span>}
              <Button size="sm" variant="outline" data-testid={`devis-pdf-${d.id}`}
                onClick={() => ouvrirPdf(`/devis/${d.id}/pdf`, `${d.numero}.pdf`).catch(() => toast.error("PDF indisponible"))}>
                <Download className="h-3 w-3 mr-1" />PDF</Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
